import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { okrService } from "@/services/okrService";
import { ObjectiveFilter, ICreateObjective, IUpdateObjective } from "@/types";

export const useObjectives = (params?: ObjectiveFilter, enabled = true) => {
  return useQuery({
    queryKey: ["objectives", params],
    queryFn: () => okrService.getObjectives(params),
    enabled,
  });
};

export const useObjective = (pid: string) => {
  return useQuery({
    queryKey: ["objectives", pid],
    queryFn: () => okrService.getObjective(pid),
    enabled: !!pid,
  });
};

export const useCreateObjective = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ICreateObjective) => okrService.createObjective(data),
    onSuccess: (objective) => {
      queryClient.invalidateQueries({ queryKey: ["objectives"] });
      queryClient.setQueryData(["objectives", objective.pid], objective);
    },
  });
};

export const useUpdateObjective = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ pid, data }: { pid: string; data: IUpdateObjective }) =>
      okrService.updateObjective(pid, data),
    onSuccess: (objective) => {
      queryClient.invalidateQueries({ queryKey: ["objectives"] });
      queryClient.setQueryData(["objectives", objective.pid], objective);
    },
  });
};

export const useDeleteObjective = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (pid: string) => okrService.deleteObjective(pid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["objectives"] });
      queryClient.invalidateQueries({ queryKey: ["key-results"] });
    },
  });
};
